import React from 'react';
import Breadcrumb from '@atlassian/jira-breadcrumbs/src/breadcrumb/component.tsx';
import type { BreadcrumbData } from '@atlassian/jira-breadcrumbs/src/types';
import { SERVICE_DESK_PROJECT } from '@atlassian/jira-common-constants/src/project-types';
import { getNextgenSettingsUrl } from '@atlassian/jira-project-settings-apps-common/src/urls';
import messages from './messages';
import type { ServicedeskChannelsBreadcrumbPropsWithIntl } from './types';

const ServicedeskChannelsBreadcrumb = ({
	children,
	projectKey,
	intl: { formatMessage },
}: ServicedeskChannelsBreadcrumbPropsWithIntl) => (
	<Breadcrumb
		breadcrumb={
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			{
				text: formatMessage(messages.channelsBreadcrumb),
				href: `${getNextgenSettingsUrl(SERVICE_DESK_PROJECT, projectKey)}/channels`,
				type: 'servicedeskChannelsBreadcrumb',
			} as BreadcrumbData
		}
	>
		{children}
	</Breadcrumb>
);

export default ServicedeskChannelsBreadcrumb;
